import { Box, Slider, Typography } from '@mui/material';

import { panelLabelSx, shapePanelSx } from './inlineMenuStyles';
import { asSliderValue } from './menuUtils';

interface LineWidthPanelProps {
  label: string;
  onChange: (lineThickness: number) => void;
  value: number;
}

export function LineWidthPanel({ label, onChange, value }: LineWidthPanelProps) {
  return (
    <Box sx={{ ...shapePanelSx, width: 170 }}>
      <Typography sx={panelLabelSx}>{label}</Typography>
      <Slider
        aria-label={label}
        max={20}
        min={1}
        onChange={(_, sliderValue) => onChange(asSliderValue(sliderValue))}
        size="small"
        value={value}
      />
    </Box>
  );
}
